import axios from "@/axios"; 
const API_URL = process.env.VUE_APP_API_BASE_URL;

export function useServiceApi() {
  

  async function getService() {
    try {
      const response = await axios.get(API_URL + "/services/");
      return response.data;
    } catch (error) {
      console.error("Error retrieving services:", error);
      throw error;
    }
  }

  async function deleteService(id) {
    try {
      const response = await axios.delete(API_URL + `/services/${id}/`);
      return response.data;
    } catch (err) {
      console.error("Error deleting Ip:", err);
      throw err;
    }
  }

  // Create a new "Ip"
  async function createService(form_data) {
    try {
      const response = await axios.post(API_URL + "/services/", form_data);
      return response.data;
    } catch (err) {
      console.error("Error creating Ip:", err);
      throw err;
    }
  }

  // Update an existing "Ip"
  async function updateService(id, form_data) {
    try {
      const response = await axios.put(API_URL + `/services/${id}/`, form_data);
      return response.data;
    } catch (err) {
      console.error("Error updating Ip:", err);
      throw err;
    }
  }

  
  
  
  return {
    getService,
    deleteService,
    createService,
    updateService,
  };
}